export default "__VITE_ASSET__gJAmXhqW__"